<template>
  <div class="uk-card-body">
    <div class="uk-margin-bottom">
      <div class="uk-grid uk-grid-small" data-uk-grid="">
        <div class="uk-first-column">Сортировка:</div>
        <div class="">
          <select class="uk-form-small uk-select" v-model="sortSelectOne" @change="sortSelectChange()">
            <option value="">--</option>
            <!--<option value="function_lose___asc">function_lose по возрастанию</option>-->
            <option value="function_lose___desc">ТОП опций с низким рейтингом</option>
            <!--<option value="function_better_than_basic___asc">function_better_than_basic по возрастанию</option>-->
            <option value="function_better_than_basic___desc">ТОП опций с высоким рейтингом</option>
          </select>
        </div>
      </div>
    </div>
    <!--header-->
    <div class="tm-background-light-gray">
      <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid>
        <!--Иконка функции-->
        <div class="uk-width-auto">
          <div style="width: 60px;" class="uk-padding-small">
            <md-icon class="uk-light">image</md-icon>
          </div>
        </div>
        <!--Название функции-->
        <div class="uk-width-expand">
          <div class="uk-padding-small uk-text-bold">
            {{ local_page_keys.description_table_header_function}}
            <a href="#" class="uk-display-inline-block uk-link-reset" :data-uk-tooltip="'title: ' + local_page_keys.description_table_header_sorting_by_function ">
              <span class="uk-icon" @click="setSortingData('translated','asc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
              </span>
              <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('translated','desc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
              </span>
            </a>
          </div>
        </div>
        <!--Переключатель фукнций-->
        <div class="uk-width-auto " v-if="isShowColumn()">
          <div style="width: 85px;" class="uk-padding-small" :data-uk-tooltip="local_page_keys.description_table_header_disable_function">
            <md-icon class="uk-light">toggle_on</md-icon>
          </div>
        </div>
        <!--Рейтинг по опциям-->
        <div class="uk-width-1-5" v-if="isShowColumn()">
          <div class="uk-padding-small uk-text-bold">
            {{local_page_keys.description_table_header_rating_by_option}}
            <a href="#" class="uk-display-inline-block uk-link-reset" :data-uk-tooltip="'title: ' + local_page_keys.description_table_header_sorting_by_rating">
              <span class="uk-icon" @click="setSortingData('average_rate_for_user_for_function_in_percentage','desc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
              </span>
              <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('average_rate_for_user_for_function_in_percentage','asc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
              </span>
            </a>
          </div>
          <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 0">
            {{local_page_keys.description_table_header_tooltip__rating_by_option}}
          </div>
        </div>
        <!--Вероятность получения заказа с данной функцией-->
        <div class="uk-width-1-3" v-if="isShowColumn()">
          <div class="uk-padding-small uk-text-bold" style="line-height: 1.2">
            {{local_page_keys.description_table_header_probability}}
            <a href="#" class="uk-display-inline-block uk-link-reset" :data-uk-tooltip="'title: ' + local_page_keys.description_table_header_sorting_by_rating">
              <span class="uk-icon" @click="setSortingData('probability_for_user','desc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
              </span>
              <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="setSortingData('probability_for_user','asc')">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
              </span>
            </a>
          </div>
          <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 0" style="width: 350px;">
            {{local_page_keys.description_table_header_tooltip_probability}}
          </div>
        </div>
        <div class="uk-width-medium">
          <div class="uk-padding-small uk-text-bold">{{local_page_keys.description_table_header_video_in_option}}</div>
        </div>
        <div class="uk-width-auto">
          <div style="width: 60px;" class="uk-padding-small"></div>
        </div>
      </div>
    </div>
    <div class="uk-padding uk-text-center" v-if="functionsList.length === 0">
      {{ local_page_keys.description_table_search_not_found}}
    </div>
    <div v-else>
      <!--list-->
      <template v-for="(functionItem, key) in functionsList">
        <div class="uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover uk-grid" :key="key" data-uk-grid>
          <!--Иконка функции-->
          <div class="uk-width-auto">
            <div style="width: 60px;" class="uk-padding-small">
              <img class="tm-func-icon" :src="functionItem.icon" alt="">
            </div>
          </div>
          <!--Название функции-->
          <div class="uk-width-expand uk-text-left" @click="$emit('openView',functionItem)" style="cursor: pointer;">
            <div class="uk-padding-small">
              {{ functionItem.translated }}
            </div>
          </div>
          <!--Переключатель фукнций-->
          <div class="uk-width-auto" v-if="Number(chosenUser) > 0 && computedChosenUserBannedFunctions['f_'+functionItem.id]">
            <div style="width: 85px;" class="uk-padding-small">

              <div class="tm-checkbox-functions-description-box">
                <input
                  class="tm-checkbox-functions-description1"
                  type="checkbox"
                  v-model="chosenUserBannedFunctions['f_' + functionItem.id]['function_state']"
                  :checked="chosenUserBannedFunctions['f_' + functionItem.id]['function_state']"
                  @click.prevent="functionsUserDisableListChange($event, chosenUser,functionItem.id, functionItem.name)"
                  :key="'checkbox_' + functionItem.id"/>
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
<!--             v-model="chosenUserBannedFunctions['f_' + functionItem.id]['function_state']"-->
<!--            {{chosenUserBannedFunctions['f_' + functionItem.id]['function_state']}}-->
<!--              <input-->
<!--                  class="tm-checkbox-functions-description"-->
<!--                  type="checkbox"-->
<!--                  v-model="chosenUserBannedFunctions['f_' + functionItem.id]['function_state']"-->
<!--                  :checked="chosenUserBannedFunctions['f_' + functionItem.id]['function_state']"-->
<!--                  @click.prevent="functionsUserDisableListChange($event, chosenUser,functionItem.id, functionItem.name)"-->
<!--                  :key="'checkbox_' + functionItem.id">-->
            </div>
          </div>
          <!--Рейтинг по опциям-->
          <div class="uk-width-1-5" v-if="isShowColumn()">
            <div class="uk-padding-small">
              <div class="uk-margin-auto" style="width: 200px">
                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                  <div class="uk-width-small">
                    <progress class="uk-progress" :class="'tm-progress-' + getProgressClass(functionItem.average_rate_for_user_for_function_in_percentage)" :value="formatPercent(functionItem.average_rate_for_user_for_function_in_percentage)" max="100"></progress>
                  </div>
                  <div>
                    {{ formatPercent(functionItem.average_rate_for_user_for_function_in_percentage) }} %
                  </div>
                </div>
              </div>
              <div class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-left" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 200; delay-show: 0; offset: 0" style="width: 350px">
                <span v-html="getToolTipForProbability( getProgressClass(functionItem.probability_for_user), functionItem.probability_for_user)"></span>
                <span @click="handleViewVideoClick(functionItem)" class="uk-margin-xsmall-left" style="cursor: pointer" title="Видео инструкция"><md-icon style="color: red">smart_display</md-icon></span>
              </div>
            </div>
          </div>
          <!--Вероятность получения заказа с данной функцией-->
          <div class="uk-width-1-3" v-if="isShowColumn()">
            <div class="uk-padding-small">
              <div class="uk-margin-auto" style="width: 200px">
                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                  <div class="uk-width-small">
                    <progress class="uk-progress" :class="'tm-progress-'+ getProgressClass(functionItem.probability_for_user)" :value="formatPercent(functionItem.probability_for_user)" max="100"></progress>
                  </div>
                  <div>
                    {{ formatPercent(functionItem.probability_for_user) }}%
                  </div>
                </div>
              </div>
              <div class="uk-dropdown tm-dropdown tm-dropdown-left-center uk-text-left" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-center; delay-hide: 200; delay-show: 0; offset: 0" style="width: 350px">
                <span v-html="getToolTipForProbability( getProgressClass(functionItem.probability_for_user), functionItem.probability_for_user)"></span>
                <span @click="handleViewVideoClick(functionItem)" class="uk-margin-xsmall-left" style="cursor: pointer" title="Видео инструкция"><md-icon style="color: red">smart_display</md-icon></span>
              </div>
            </div>
          </div>
          <div class="uk-width-medium">
            <div class="uk-padding-small" v-html="getVideoLinks(functionItem)"></div>
          </div>
          <div class="uk-width-auto">
            <div class="uk-padding-small uk-flex uk-text-center uk-flex-center" style="min-width: 50px;">
              <button type="button"
                      @click="$emit('copyLink',functionItem.name)"
                      data-uk-toggle="target: #edit-func"
                      data-uk-icon="file-edit" style="padding: 0 5px;"
                      class="uk-icon uk-link-text" :data-uk-tooltip="'title: ' + local_page_keys.description_table_copy_link">
                <md-icon>content_copy</md-icon>
              </button>
            </div>
          </div>
        </div>
        <hr class="uk-margin-remove" :key="key+'_0'">
      </template>
      <div class="uk-margin"></div>
    </div>
    <!--Модалка для "Переключатель фукнций"-->
    <template>
      <form id="password-modal" @submit.prevent="verifyPassword" data-uk-modal>
        <div class="uk-modal-dialog">
          <button type="button" data-uk-close class="uk-close uk-close-large uk-modal-close-outside uk-icon"></button>
          <div class="uk-modal-header">
            <div class="uk-card-title">Enter Password</div>
          </div>

          <div class="uk-modal-body">
            <input
              v-model="password"
              class="uk-input"
              type="password"
              placeholder="Password"
              autocomplete="off"
              required/>
          </div>
          <div class="uk-modal-footer uk-text-right">
            <button class="uk-button uk-button-success" type="submit">Submit</button>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
export default  {
  data() {
    return {
      sort: {
        field: 'name',
        type: 'asc',
      },
      sortSelectOne: '',
      sortSelect: {
        field: 'name',
        type: 'asc'
      },
      functionsList: [],
      functionsUserDisableList: {
      },
      path: process.env.VUE_APP_API_URL,
      items: [],
      password: '',
      functionsUserDisableChange:{},
      modal:{},
      showModal:false,
      modalKey:0,
      getterKey:0,
    };
  },
  props: {
    functions: {type: [Array, Object]},
    searchString: String,
    local_page_keys: {type: Object},
    chosenUserBannedFunctions: {type: Object},
    role: String ,
    chosenUser: Number,
    isLoading: Boolean,
  },
  methods: {
    openModal(modalId) {
      this.showModal = true;
      this.$nextTick(() => {
        this.modal = UIkit.modal(`${modalId}`);
        this.modal.show();
      });
    },
    openNotification(options) {
      this.$nextTick(() => {
        UIkit.notification(options);
      });
    },
    closeModal() {
      if (this.modal && Object.keys(this.modal).length > 0) {
        this.modal.hide();
        this.showModal = false;
        // Force Vue to re-render the modal by changing the key
        this.modalKey += 1;
      }
    },
    functionsUserDisableListChange(event,chosenUser,functionItemId, functionItemName){
      event.preventDefault();
      event.stopPropagation();
      this.functionsUserDisableChange = {
        chosenUser:chosenUser,
        functionItemId:functionItemId,
        functionItemName:functionItemName,
        status:event.target.checked,
        event:event
      };
      this.openModal('#password-modal');
    },

    async updateBanFunctionForChosenUser(chosenUser,functionItemId, functionItemName){
      this.getterKey++;
      await this.$store.dispatch('functionsEdit/banFunctionForChosenUser', {
        user_id: this.functionsUserDisableChange.chosenUser,
        function_id: this.functionsUserDisableChange.functionItemId,
        function_state: this.functionsUserDisableChange.status,
        function_name:  this.functionsUserDisableChange.functionItemName});
      let data = this.$store.getters['functionsEdit/banFunctionForChosenUser'](this.getterKey);
    },
    async verifyPassword() {
      this.getterKey++;
      await this.$store.dispatch('adminAppConfig/checkAdminPassword', {password: this.password});
      let data = await this.$store.getters['adminAppConfig/checkAdminPassword'](this.getterKey);

      if ('success' in data && data.success === true) {
        this.password = '';
        this.chosenUserBannedFunctions['f_' +  this.functionsUserDisableChange.functionItemId ]['function_state'] = this.functionsUserDisableChange.status;

        this.closeModal();
        this.openNotification({ message: 'Password verified successfully!', status: 'success' });
        await this.updateBanFunctionForChosenUser();
        this.rebuild();
      } else {
        this.password = '';
        if(this.chosenUserBannedFunctions['f_' +  this.functionsUserDisableChange.functionItemId ]['function_state'] !== this.functionsUserDisableChange.status) {
          this.chosenUserBannedFunctions['f_' +  this.functionsUserDisableChange.functionItemId ]['function_state'] = !this.functionsUserDisableChange.status;
        }
        this.closeModal();
        this.openNotification({ message: 'Password verification FAILED!', status: 'danger' });
      }
      this.password = '';

    },
    sortSelectChange(event){
      this.sortSelect = {
        name: 'name',
        type: 'asc',
      };
      if(this.sortSelectOne.indexOf('___') > -1) {
        let sortSelectArr = this.sortSelectOne.split('___');

        this.sortSelect = {
          name: sortSelectArr[0],
          type: sortSelectArr[1],
        };

      }
      this.setSortingData(this.sortSelect.name, this.sortSelect.type, true);
    },
    sorting(field, type) {
      if (type == 'asc') {
        this.functionsList = this.functionsList.sort((a, b) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0));
      } else {
        this.functionsList = this.functionsList.sort((a, b) => (b[field] > a[field]) ? 1 : ((a[field] > b[field]) ? -1 : 0));
      }
    },
    setSortingData(field, type, externalSelect = false) {
      this.sort.type = type == 'asc' ? 'asc' : 'desc';
      this.sort.field = field;
     if(!externalSelect && this.sortSelectOne != '') this.sortSelectOne = '';
      this.rebuild();
    },
    search() {
      const searchStringLower = this.searchString.toLowerCase(); // Преобразование строки к нижнему регистру
      this.functionsList = this.functionsList.filter(o => o.translated.toLowerCase().includes(searchStringLower)); // Преобразование и сравнение в нижнем регистре
    },
    async rebuild() {

      this.functionsList = this.functions;
      await this.search();
      await this.sorting(this.sort.field, this.sort.type);
      this.closeModal();

    },
    getVideoLinks(items) {
      const videoLessons = items.examples.filter(item => item.type === "video" && item.video_lesson);
      const videoLinks = videoLessons.map(item => ({
        url: item.video_lesson,
      }));
      return videoLinks.map(item => `<a href="${item.url}" target="_blank"><i class="md-icon md-icon-font md-theme-default">smart_display</i></a>`).join("\n");
    },
    isShowColumn (){
      return !this.isLoading && ( this.role === 'retoucher' || ( this.role !== 'pro_retoucher' && this.chosenUser) );
    },
    getProgressClass(value) {
      value = parseInt(value);
      if (value >= 0 && value <= 25) {
        return "grey";
      } else if (value > 25 && value <= 50) {
        return "red";
      } else if (value > 50 && value <= 64) {
        return "orange";
      } else if (value > 64 && value <= 74) {
        return "yellow";
      } else if (value > 74 && value <= 84) {
        return "light-green";
      } else if (value > 84) {
        return "green";
      } else {
        return "";
      }
    },
    getToolTipForProbability(colorClass, value) {
      let color = colorClass.replace(/-/g, "_");
      let percent = this.formatPercent(value);
      return this.local_page_keys['tooltip_for_probability_' + color] + ' <b>' + percent + '%</b>. '
          + this.local_page_keys['tooltip_for_probability_' + color + '_addition']
          + '<br>' + this.local_page_keys.try_keep_rating_alert;
    },
    formatPercent(value) {
      return parseInt(value) || 0;
    },
    handleViewVideoClick(functionItem) {
      const openDropdowns = document.querySelectorAll('.uk-dropdown.uk-open');
      openDropdowns.forEach(dropdown => {
        dropdown.classList.remove('uk-open');
      });
      this.$emit('openViewVideo', functionItem);
    },
    getQueryParams() {
      const queryParams = {};
      const queryString = window.location.search.substring(1);
      const params = queryString.split('&');

      params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = value;
      });

      return queryParams;
    },
    removeQueryParams() {
      const url = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, url);
    },

  },
  async created() {

    await this.rebuild();
    const queryParams = this.getQueryParams();
    this.removeQueryParams();

    if(Object.keys(queryParams).length > 0 && 'field' in queryParams && 'type' in queryParams){

      this.sortSelectOne = queryParams.field + '___' + queryParams.type;

      this.sortSelectChange();
    }


  },
  computed:{
    computedChosenUserBannedFunctions(){
      return this.chosenUserBannedFunctions;
    }
  },
  watch: {
    searchString: function (newVal, oldVal) {
      this.rebuild();
    },
    functions: function (newVal, oldVal) {
      this.rebuild();
    }
  }
}
</script>
<style>
  @import '../../../assets/css/uikit/progress.css';
  .uk-progress.tm-progress-grey::-webkit-progress-value {
    background-color: #888888;
  }
  .uk-progress.tm-progress-grey::-moz-progress-bar {
    background-color: #888888;
  }
  .uk-progress.tm-progress-grey::-ms-fill {
    background-color: #888888;
  }


  .uk-progress.tm-progress-red::-webkit-progress-value {
    background-color: #ff5656;
  }
  .uk-progress.tm-progress-red::-moz-progress-bar {
    background-color: #ff5656;
  }
  .uk-progress.tm-progress-red::-ms-fill {
    background-color: #ff5656;
  }


  .uk-progress.tm-progress-orange::-webkit-progress-value {
    background-color: #ffbe45;
  }
  .uk-progress.tm-progress-orange::-moz-progress-bar {
    background-color: #ffbe45;
  }
  .uk-progress.tm-progress-orange::-ms-fill {
    background-color: #ffbe45;
  }


  .uk-progress.tm-progress-yellow::-webkit-progress-value {
    background-color: #f5f262;
  }
  .uk-progress.tm-progress-yellow::-moz-progress-bar {
    background-color: #f5f262;
  }
  .uk-progress.tm-progress-yellow::-ms-fill {
    background-color: #f5f262;
  }


  .uk-progress.tm-progress-light-green::-webkit-progress-value {
    background-color: #91ce36;
  }
  .uk-progress.tm-progress-light-green::-moz-progress-bar {
    background-color: #91ce36;
  }
  .uk-progress.tm-progress-light-green::-ms-fill {
    background-color: #91ce36;
  }
  * {
    //background-color: #555;
    //color: #eee;
  }

  .tm-checkbox-functions-description {
    appearance: none;
    width: 26px;
    height: 26px;
    border-radius: 7px;
    text-align: center;
    font-size: large;
    background-color: green;
    transition: 250ms;
    box-shadow: 0 0 20px #222;
  }
  .tm-checkbox-functions-description:before {
    content: "✔";
  }
  .tm-checkbox-functions-description:checked:before {
    content: "✖";
  }
  .tm-checkbox-functions-description:checked {
    background-color: red;
    box-shadow: inset 0 0 5px #222;
  }












  .tm-checkbox-functions-description-box .knobs,
  .tm-checkbox-functions-description-box .layer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .tm-checkbox-functions-description-box {
    position: relative;
    top: 50%;
    width: 55px;
    height: 36px;
    margin: 0 auto 0 auto;
    overflow: hidden;
  }

  .tm-checkbox-functions-description-box,
  .tm-checkbox-functions-description-box .layer {
    border-radius: 100px;
  }

  .tm-checkbox-functions-description-box .tm-checkbox-functions-description1 {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }

  .tm-checkbox-functions-description-box .knobs {
    z-index: 2;
  }
  /* фон в режиме ON */
  .tm-checkbox-functions-description-box .layer {
    width: 100%;
    background-color: rgb(76 175 80 / 20%);
    transition: 0.3s ease all;
    z-index: 1;
  }
  /* фон в режиме OFF */
  .tm-checkbox-functions-description-box .knobs:before {
    content: "ON";
    position: absolute;
    box-sizing: content-box;
    top: 4px;
    left: 4px;
    width: 20px;
    height: 10px;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 9px 4px;
    background-color: #4caf50;
    border-radius: 50%;
    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
  }

  .tm-checkbox-functions-description-box .tm-checkbox-functions-description1:checked + .knobs:before {
    content: "OFF";
    left: 23px;
    background-color: #f44336;
  }

  .tm-checkbox-functions-description-box .tm-checkbox-functions-description1:checked ~ .layer {
    background-color: rgb(244 67 54 / 20%);
  }

  .tm-checkbox-functions-description-box .knobs,
  .tm-checkbox-functions-description-box .knobs:before,
  .tm-checkbox-functions-description-box .layer {
    transition: 0.3s ease all;
  }

</style>